import React, { useEffect, useState } from 'react';
import { EventBus } from 'src/common/EventBus';
import { STEP_EDITOR_CONTENT_OPTION_INITIAL } from 'src/editor/constants';
import { StepEditor } from 'src/editor/step-editor';
import { StepEditorContentConfigureStageTypeEnum } from 'src/editor/step-editor/content/configure/stage-type.enum';
import { StepEditorInitialStage } from 'src/editor/step-editor/initial-stage';
import { useEditorContext } from 'src/store/editor';
import { useStepEditorContext } from 'src/store/step-editor';
import { Nullable } from 'src/types/nullable.type';


interface PageStepEditProps {
  nodeId?: string;
  documentId?: string;
  stepId?: Nullable<string>;
}

export const PageStepEdit = ({ nodeId, documentId, stepId = null }: PageStepEditProps) => {
  const { setCurrentActiveNodeId } = useEditorContext();
  const [showInitialStage, setShowInitialStage] = useState(false);
  const { setContentOption, setCurrentConfigurationStage, resetContent } = useStepEditorContext();

  useEffect(() => {
    if (nodeId) {
      setCurrentActiveNodeId(parseInt(nodeId, 10));
    }
  }, [nodeId, setCurrentActiveNodeId]);

  useEffect(() => {
    const onEditorResetContent = () => {
      resetContent();
      setCurrentConfigurationStage(StepEditorContentConfigureStageTypeEnum.NEW);
      setContentOption(STEP_EDITOR_CONTENT_OPTION_INITIAL);
      setShowInitialStage(true);
    };

    EventBus.on('editor:reset-content', onEditorResetContent);

    return () => {
      EventBus.off('editor:reset-content', onEditorResetContent);
    };
  }, []);

  if (!nodeId) {
    return null;
  }

  if (showInitialStage) {
    return <StepEditorInitialStage stepId={nodeId} />;
  }

  return (
    <StepEditor
      activeStage={StepEditorContentConfigureStageTypeEnum.CONFIGURE}
      nodeId={nodeId}
      stepId={stepId}
      documentId={documentId}
    />
  );
};
